module.exports = __webpack_public_path__ + "static/video-d55bddf8d62910879ed9f605522149a8.mp4";